(() => {
  const container = document.querySelector(".shopify-policy__container");
  const body = container?.querySelector(".shopify-policy__body");
  const content = body?.querySelector(".rte");

  if (!container || !body || !content || container.dataset.lonevilePolicyReady === "true") {
    return;
  }

  const normalize = (value) => value.replace(/\s+/g, " ").trim();
  const path = window.location.pathname;
  const isGerman = document.documentElement.lang.toLowerCase().startsWith("de");

  if (path.endsWith("/shipping-policy")) {
    const textWalker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);

    while (textWalker.nextNode()) {
      textWalker.currentNode.nodeValue = textWalker.currentNode.nodeValue
        .replace(/5,90\s*€/g, "4,90 €")
        .replace(/€\s*5\.90/g, "€4.90");
    }
  }

  let category = isGerman ? "Rechtliches" : "Legal";
  let introLabel = isGerman ? "Überblick" : "Overview";

  if (path.endsWith("/shipping-policy")) {
    category = "Service";
    introLabel = isGerman ? "Allgemeines" : "Overview";
  } else if (path.endsWith("/refund-policy")) {
    category = "Service";
  } else if (path.endsWith("/legal-notice")) {
    introLabel = isGerman ? "Anbieter" : "Provider";
  }

  const title = container.querySelector(".shopify-policy__title");
  if (title) {
    const heading = title.querySelector("h1");

    if (heading && path.endsWith("/shipping-policy")) {
      heading.textContent = isGerman ? "Versandkosten & Lieferzeit" : "Shipping Costs & Delivery Time";
    }

    const eyebrow = document.createElement("p");
    eyebrow.className = "lonevile-policy__eyebrow";
    eyebrow.textContent = category;
    title.prepend(eyebrow);
  }

  for (const child of [...content.children]) {
    if (child.matches("div.e24ig-result-text-wrap")) {
      child.replaceWith(...child.children);
    }
  }

  const trimLeadingBreaks = (element) => {
    while (element.firstChild) {
      const first = element.firstChild;
      const isEmptyText = first.nodeType === Node.TEXT_NODE && !first.textContent.trim();
      if (first.nodeName === "BR" || isEmptyText) {
        first.remove();
        continue;
      }
      break;
    }
  };

  const isHeading = (element) => {
    if (element.tagName !== "P") {
      return false;
    }

    const text = normalize(element.textContent || "");
    if (!text) {
      return false;
    }

    const underlined = [...element.querySelectorAll("span, u")].some((candidate) => {
      const decoration = getComputedStyle(candidate).textDecorationLine;
      return normalize(candidate.textContent || "") === text && (candidate.tagName === "U" || decoration.includes("underline"));
    });

    const bold = [...element.querySelectorAll("strong, b")].some((candidate) => {
      return normalize(candidate.textContent || "") === text;
    });

    return underlined || (bold && text.length <= 120);
  };

  const fragment = document.createDocumentFragment();
  let currentRow = null;
  let currentContent = null;

  const finishRow = () => {
    if (currentRow && currentContent && currentContent.children.length === 0) {
      currentRow.classList.add("lonevile-policy-row--section");
    }
  };

  const startRow = (label, modifier) => {
    currentRow = document.createElement("section");
    currentRow.className = "lonevile-policy-row";

    if (modifier) {
      currentRow.classList.add(modifier);
    }

    const heading = document.createElement("h2");
    heading.className = "lonevile-policy-row__label";
    heading.textContent = label;

    currentContent = document.createElement("div");
    currentContent.className = "lonevile-policy-row__content";

    currentRow.append(heading, currentContent);
    fragment.append(currentRow);
  };

  for (const element of [...content.children]) {
    trimLeadingBreaks(element);
    const text = normalize(element.textContent || "");

    if (!text || /^_{8,}$/.test(text)) {
      element.remove();
      continue;
    }

    if (isHeading(element)) {
      finishRow();
      startRow(text);
      element.remove();
      continue;
    }

    if (!currentRow) {
      startRow(introLabel, "lonevile-policy-row--intro");
    }

    currentContent.append(element);
  }

  finishRow();
  content.replaceChildren(fragment);
  container.dataset.lonevilePolicyReady = "true";
})();
